import { useEffect, useState } from "react";
import { api } from "./api";

let promise = null;
const load = () => {
  if (!promise) promise = api.get("/content").then((r) => r.data).catch(() => ({}));
  return promise;
};

export const useContent = () => {
  const [c, setC] = useState({});
  useEffect(() => { load().then(setC); }, []);
  return c;
};

export const pick = (c, key, fallback) => (typeof c?.[key] === "string" && c[key].trim() ? c[key] : fallback);
